import BaseModel from './BaseModel'

export default class CarModelModel extends BaseModel {
    get schema() {
        return {
            id: ['id', undefined, value => value],
            name: ['name', undefined, value => value],
            markId: ['markId', undefined, value => parseInt(value)],
        }
    };

    static attributeLabels = {
        id: 'ID',
        name: 'Название',
        markId: 'Марка',
    }
}
